import { Api } from "../../common/lib/httpRequest";
import {
  GetListPackageResponse
} from "../utils/types";

export const apiLogin = (params: any): Promise<GetListPackageResponse> => {
  return Api.get(`api/v1/stockpick/packages/get-all`, params);
};